module.exports = __webpack_public_path__ + "static/img/Risk240129EN.37bda5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Risk240129EN.jpg
// module id = aLjs
// module chunks = 1